import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "@api";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { Pregunta } from "@modelo/proceso/Pregunta.model";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";


@Component({
    selector: 'preparacionpregunta_obligatorio',
    templateUrl: './preparacionevaluacionpregunta_obligatorio.component.html',
    styleUrls: ['../../preparacionevaluacion.component.scss']
})


export class PreparacionEvaluacionPreguntaObligatorio implements AfterViewInit {
    consulta!: boolean;
    entidad: PeriodoEvaluacion;
    entidadpregunta: Pregunta;
    @Input() id!: number;
    @Input() idpuesto!: number;
    @Input() iddepartamento!: number;
    @Input() disabled!: boolean;
    @Output() salir = new EventEmitter();

    DataPeriodoPorPlantilla: any[];
    ListPreguntas: any[]
    
    constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService){
        this.entidad = new PeriodoEvaluacion();
        this.entidadpregunta = new Pregunta();

        this.DataPeriodoPorPlantilla = [];
        this.ListPreguntas = [];
    }

    ngAfterViewInit(){
        this.SetPeriodoPorPlantilla();
    }
    SetPeriodoPorPlantilla(){
        this.appService.Post("planeacion/preparacionevaluacion/preparacion/puesto/pregunta/buscar",{"periodoevaluacionid":this.id,"puestoid":this.idpuesto, "tipoclaseid":1, "departamentoid":this.iddepartamento}).then(res => {
             if (res.status == RespuestaEstatusEnum.Success) {
                this.ListPreguntas = res.data;
                this.ListPreguntas = this.ListPreguntas.filter(x=> x.Seccionid == '1');
             }
        });
    }
}